import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 30,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

export const invalidateQueries = {
  afterClientMutation: () => {
    queryClient.invalidateQueries({ queryKey: ['clients'] })
    queryClient.invalidateQueries({ queryKey: ['dashboard'] })
  },
  afterFacilityMutation: () => {
    queryClient.invalidateQueries({ queryKey: ['facilities'] })
    queryClient.invalidateQueries({ queryKey: ['clients'] })
    queryClient.invalidateQueries({ queryKey: ['quotes'] })
    queryClient.invalidateQueries({ queryKey: ['dashboard'] })
  },
  afterQuoteMutation: () => {
    queryClient.invalidateQueries({ queryKey: ['quotes'] })
    queryClient.invalidateQueries({ queryKey: ['dashboard'] })
  },
  afterFacilityDetailsMutation: (facilityId: string) => {
    queryClient.invalidateQueries({ queryKey: ['facility', facilityId] })
  },
  all: () => {
    queryClient.invalidateQueries()
  },
}
